"use client";

import { useEffect, useState, type ComponentType } from "react";

type Chrome = {
  Chatbot: ComponentType;
  MobileQuoteBar: ComponentType;
  CursorGlow: ComponentType;
};

export function DeferredChrome() {
  const [mods, setMods] = useState<Chrome | null>(null);

  useEffect(() => {
    let cancelled = false;
    let loaded = false;

    const load = () => {
      if (loaded) return;
      loaded = true;
      Promise.all([
        import("./chatbot"),
        import("./mobile-cta"),
        import("./cursor-glow"),
      ]).then(([chat, cta, glow]) => {
        if (cancelled) return;
        setMods({
          Chatbot: chat.Chatbot,
          MobileQuoteBar: cta.MobileQuoteBar,
          CursorGlow: glow.CursorGlow,
        });
      });
    };

    const onInteract = () => load();
    window.addEventListener("pointerdown", onInteract, { once: true, passive: true });
    window.addEventListener("keydown", onInteract, { once: true });
    const timer = window.setTimeout(load, 12000);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      window.removeEventListener("pointerdown", onInteract);
      window.removeEventListener("keydown", onInteract);
    };
  }, []);

  if (!mods) return null;

  const { Chatbot, MobileQuoteBar, CursorGlow } = mods;
  return (
    <>
      <CursorGlow />
      <MobileQuoteBar />
      <Chatbot />
    </>
  );
}
